import { FunctionComponent, ReactNode } from 'react'
import { Box, Chip, Typography } from '@black-bear-energy/rucksack'

const SECTION_CONFIG = {
  new: { chipLabel: 'New in this release', chipColor: 'secondary' as const },
  next: { chipLabel: 'Coming soon', chipColor: 'primary' as const },
}

export const ReleaseSection: FunctionComponent<{
  section: 'new' | 'next'
  icon: ReactNode
  heading: string
  children: ReactNode
}> = ({ section, icon, heading, children }) => {
  const { chipLabel, chipColor } = SECTION_CONFIG[section]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Chip
        label={chipLabel}
        color={chipColor}
        sx={{ alignSelf: 'flex-start' }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon}
        <Typography variant="subtitle2">{heading}</Typography>
      </Box>
      {children}
    </Box>
  )
}
